<template>
  <Nav-bar :has_back="true" :has_right="false" title="微信授权信息"></Nav-bar>
  <div class="top-margin"></div>
  <div class="display_column container">
    <span class="t-f22-c28 font-bold">授权微信登录</span>
    <span class="t-f14-c78 m-t-10">点击下面按钮即可授权微信登录</span>
    <img src="@/images/wechat_auth.png" class="w-i" />
    <van-button type="primary" size="normal" class="main-btn" @click="toAuth"
      >同意</van-button
    >
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import { useRouter } from "vue-router";
import authHelper from "@/helpers/auth_helper";

// import tokenHelper from "@/helpers/token_helper";
let router;

export default {
  components: {
    NavBar:NavBar
  },
  setup() {
    router = useRouter();
    function toAuth() {
      authHelper.wechatAuthorize();
    }
    return { router, toAuth };
  },
};
</script>

<style scoped>
body {
  background: #fff !important;
}
.main-btn {
  margin: 0 auto;
  margin-top: 30px;
  width: 245px;
}
.container {
  text-align: center;
  margin-top: 80px;
}
.w-i {
  height: 200px;
  width: 210px;
  margin: 0px auto;
  margin-top: 20px;
}
</style>